import React from "react";
import useEntity from "../../../hooks/useMembersGroupUser";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./MembersGroupUserListHeader";
import EntityListSearch from "./MembersGroupUserListSearch";
import {useLocation} from "react-router";
import MembersGroupUserListPagination from "./MembersGroupUserListPagination";
import * as Api from "../../../apis/MembersGroupUser.api";
import { MembersGroupUser } from "../../../types/models/MembersGroupUser";
import { PrimaryMembersGroupUser } from "../../../types/models/MembersGroupUser";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";
import { PrimaryUser } from "../../../../auth/types/models/User";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import MembersGroupUserListItemTools from "./MembersGroupUserListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    membersGroupId?: ID,
    ownedMembersGroupId?: ID,
    userId?: ID,
    };

const MembersGroupUserListItem = (props: IProps) => {
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('MembersGroupUser')

    
    
    
    
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          
            Api.useGetMembersGroupUserListQuery({ 
                  page, pageSize 
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: MembersGroupUser) => routeLocation.pathname.endsWith('members-group-users') ?
        `${PrimaryMembersGroupUser.fromEntity(entity).toPath()}`
        :
        `members-group-users/${PrimaryMembersGroupUser.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: MembersGroupUser) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                
                <TableContainer>

                    


                    

                    

                    

                    
        
                    
                        <Table stickyHeader data-testid="MembersGroupUser-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    { query.membersGroupId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'membersGroupId') }
                                                direction={ orderBys.find((item) => item.name === 'membersGroupId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('membersGroupId')}
                                            >
                                            
                                                <Trans>Members Group</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.ownedMembersGroupId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'ownedMembersGroupId') }
                                                direction={ orderBys.find((item) => item.name === 'ownedMembersGroupId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('ownedMembersGroupId')}
                                            >
                                            
                                                <Trans>User</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryMembersGroupUser.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        { query.membersGroupId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <MembersGroupLink id={ item.membersGroupId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.ownedMembersGroupId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <UserLink id={ item.ownedMembersGroupId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <MembersGroupUserListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Members Group Users</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <MembersGroupUserListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default MembersGroupUserListItem;
